module.exports = __webpack_public_path__ + "img/icon_map_6_off_001.addae113.png";